// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2Tumu","navText":"Navbar_navText__3WStR","navLogo":"Navbar_navLogo__8Wpc9","imgLogo":"Navbar_imgLogo__1JObC"};